/* eslint-disable */
export default {
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        getRandomInt(min, max) {
            return Math.floor(Math.random() * (max - min)) + min;
        },
        capitalize(s) {
            if (typeof s !== "string") return "";
            const value = s.charAt(0).toUpperCase() + s.slice(1);
            return value;
        },
        capitalizeFirstLetter(string) {
            const text =
                string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
            return text;
        },
        isEmptyObj(obj) {
            // return 'hey';
            return Object.keys(obj).length === 0;
        }
    }
};
